var _circle, _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F3EEFE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.416,
    y: 11.584,
    width: 15.167,
    height: 16.833,
    rx: 1.25,
    stroke: "#8178C0",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 15h6.667",
    stroke: "#8178C0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.416 23.146v-3.09c.363.02.83-.007 1.253-.218l1.33-.666 1.332.666c.422.21.89.238 1.252.218v3.09a2.25 2.25 0 01-1.244 2.012l-1.34.67-1.339-.67a2.25 2.25 0 01-1.244-2.012z",
    stroke: "#8178C0",
    strokeWidth: 1.5
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNGM0VFRkUiLz4KPHJlY3QgeD0iMTIuNDE2NSIgeT0iMTEuNTgzNSIgd2lkdGg9IjE1LjE2NjciIGhlaWdodD0iMTYuODMzMyIgcng9IjEuMjUiIHN0cm9rZT0iIzgxNzhDMCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTE2LjY2NjUgMTVIMjMuMzMzMiIgc3Ryb2tlPSIjODE3OEMwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy40MTY1IDIzLjE0NjFWMjAuMDU2QzE3Ljc3ODUgMjAuMDc2NSAxOC4yNDY1IDIwLjA0ODcgMTguNjY4NiAxOS44Mzc2TDE5Ljk5OTggMTkuMTcyTDIxLjMzMTEgMTkuODM3NkMyMS43NTMxIDIwLjA0ODcgMjIuMjIxMSAyMC4wNzY1IDIyLjU4MzIgMjAuMDU2VjIzLjE0NjFDMjIuNTgzMiAyMy45OTgzIDIyLjEwMTcgMjQuNzc3NCAyMS4zMzk0IDI1LjE1ODVMMTkuOTk5OCAyNS44MjgzTDE4LjY2MDMgMjUuMTU4NUMxNy44OTggMjQuNzc3NCAxNy40MTY1IDIzLjk5ODMgMTcuNDE2NSAyMy4xNDYxWiIgc3Ryb2tlPSIjODE3OEMwIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";
export { SvgInsurance as ReactComponent };